import React from 'react';
import { connect } from 'react-redux';
import { useIsMobileDimension } from '@beef/ui-kit/hooks';
import { Flex, NText } from '@fttb/common';
import PropTypes from 'prop-types';
import { getCheckTitle, getCheckTitleAltTemplate } from "../../../../store/blocks/checkAddress/selectors";
import { templateParser } from "../../../../utils";
var _MultiHeading = function _MultiHeading(_ref) {
  var children = _ref.children,
    childrenAlt = _ref.childrenAlt,
    className = _ref.className;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(NText, {
    className: className,
    color: "grey95",
    size: "size4-m",
    "data-t-id": "components-MultiHeading"
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "left",
    "data-t-id": "components-MultiHeading"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    className: "mar-r-m"
  }, /*#__PURE__*/React.createElement(NText, {
    className: isMobile ? 'mar-b-2xs' : 'mar-b-xs',
    color: "primary",
    size: "size1-m"
  }, children), /*#__PURE__*/React.createElement(NText, {
    color: "grey60",
    size: "size5-r-s"
  }, childrenAlt))));
};
_MultiHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  childrenAlt: PropTypes.node,
  className: PropTypes.string
} : {};
export var MultiHeading = connect(function (state, ownProps) {
  return {
    children: getCheckTitle(state),
    childrenAlt: templateParser(getCheckTitleAltTemplate(state), {
      phone: ownProps.phone
    })
  };
})(_MultiHeading);